import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../gd-components/base-component/base-component";

import Popover from "src/core/gd-components/gd-popover/popover";
import VScroll from 'src/core/gd-components/scrolling/custom-v-scroll/v-scroll.tsx';
import Search from '../../../../gd-components/popover-menu/search/search';

import Classes from 'classnames';

import Option from "./option";

class PopoverSelect extends BaseComponent {

    static propTypes = {

        options: PropTypes.array.isRequired,  // yes options not items ... better name
        optionType: PropTypes.oneOf(['text', 'icon-text']),

        placeholder: PropTypes.string,
        disabled: PropTypes.bool,                        // do we need it ?

        // look and feel
        size: PropTypes.oneOf(['big']),   // big small 36 / 30

        // this is value (not clicked current value)
        renderValue: PropTypes.oneOf(['text', 'icon-text', 'func']), // render value view name
        renderValueFunc: PropTypes.func,        // func for external render function if passwed used to render instead of default

        // this is for dropdown
        // renderOption: PropTypes.oneOf(['text', 'icon-text', 'func']).isRequired, // render value view name
        // renderOptionFunc: PropTypes.func,        // func for external render function if passwed used to render instead of default

        currentValue: PropTypes.any,   // curent select element value

        // advanced options
        searchable: PropTypes.bool,
        keyboardNavigation: PropTypes.bool,

        showHelp: PropTypes.bool,
        manageLabel: PropTypes.string,

        // Callbacks
        onUserSelect: PropTypes.func,
        // emptyRenderer: PropTypes.func,
        // optionRenderer: PropTypes.func,
        // valueRenderer: PropTypes.func,

        onOptionSelect: PropTypes.func,
        onManageOptions: PropTypes.func,

        hidePopover: PropTypes.func,
        onTogglePopover: PropTypes.func,
        popoverFitTargetWidth: PropTypes.bool,
        popoverStyle: PropTypes.object,
        popoverClass: PropTypes.string,
        popoverContentClass: PropTypes.string,
        outsideClickIgnoreClass: PropTypes.string,

        // Popover position
        attachment: PropTypes.string,
        targetAttachment: PropTypes.string,
        targetOffset: PropTypes.string,
        scrollContentStyle: PropTypes.object,

        // iconSize: PropTypes.oneOf(['tiny', '22']),
        // iconPosition: PropTypes.oneOf(['left', 'right'])
    };

    static defaultProps = {
        attachmentType: "full",
        attachment: "top center",
        targetAttachment: "bottom center",
        targetOffset: "-3px 0", // -3px to make it appear right under the line

        renderValue: 'text',

        popoverFitTargetWidth: true,

        searchable: true,
        keyboardNavigation: false
    };

    constructor(props) {
        super(props);

        this.state = {
            searchString: null,
            currentCursorKey: 0 // - not in use at the moment
        };

        this._bind('onSearchChange','handleSelectItem');

    }

    // Not in use at the moment - there are too many issues here
    onPopoverKeyDown(event) {
        return false;
        /*if (!this.props.keyboardNavigation) return;

        const { searchString, currentCursorKey } = this.state;
        const filterOptions = _.filter(this.props.options.slice(), i=>!searchString || i.label.includes(searchString));

        let newValue;
        switch(event.key){
            case 'ArrowUp':
                newValue = currentCursorKey - 1;
                if (newValue < 0) newValue = 0;
                this.setState({currentCursorKey: newValue});
                break;

            case 'ArrowDown':
                newValue = currentCursorKey + 1;
                if (newValue > filterOptions.length - 1) newValue = filterOptions.length - 1;
                this.setState({currentCursorKey: newValue});
                break;

            case 'Enter':
                const filterItem = filterOptions[currentCursorKey];
                if (filterItem) this.handleSelectItem(filterItem);
                break;
        }*/
    }

    onSearchChange(newValue) {
        this.setState({
            searchString: newValue
        });
    }

    handleSelectItem(item){
        this.props.onOptionSelect(item.value);

        // const { onUserSelect } = this.props;
        // if (onUserSelect) onUserSelect(item.value);
    }

    render() {

        let content;
        let optionsToDisplay = this.props.options.slice();
        optionsToDisplay = _.filter(optionsToDisplay, option=>!option.notSelectable);

        // filter if search enabled
        if (this.props.searchable && this.state.searchString) {
            const searchString = this.state.searchString.toLowerCase()
            optionsToDisplay = _.filter(optionsToDisplay.slice(), i=>i.label.toString().toLowerCase().includes(searchString))
        }

        if (optionsToDisplay && optionsToDisplay.length>0) {
            content = (
                <VScroll minDragHeight={10} style={this.props.scrollContentStyle}>
                    <div className="gd-select-group gd-popup-menu-items size-13">
                        {optionsToDisplay.map((item, key)=>{

                            const isSelected = (this.props.multiselect)
                                ?this.props.currentValue.includes(item.value)
                                :item.value === this.props.currentValue;

                            const selectClass = Classes("action", {
                                'selected': isSelected,
                                'cursor-position': this.props.keyboardNavigation && this.state.currentCursorKey === key
                            });

                            return <Option className={selectClass}
                                                       key={item.value || item.label}
                                                       multiselect={this.props.multiselect}
                                                       item={item}
                                                       onItemSelected={this.handleSelectItem}
                                                       renderFunc={this.props.renderOptionFunc}
                                                        isSelected={isSelected}
                            />;
                        })}
                    </div>
                </VScroll>
            );
        } else {
            content = (
                <div className="nothing-found" onClick={this.props.hidePopover}>
                    {this.props.emptyRenderer ? this.props.emptyRenderer() : "Nothing found"}
                </div>
            );
        }

        const popoverClasses = Classes("gd-select-new-popover", this.props.popoverClass, {
            'with-help': !!this.props.onManageOptions
        })

        return (
            <Popover popoverClass={popoverClasses}
                     className={this.props.popoverContentClass}
                     attachmentType={this.props.attachmentType}
                     attachment={this.props.attachment}
                     targetAttachment={this.props.targetAttachment}
                     targetOffset={this.props.targetOffset}
                     onKeyDown={this.onPopoverKeyDown}
                     onClickOutside={()=>{if (this.props.hidePopover) this.props.hidePopover()}}
                     outsideClickIgnoreClass={this.props.outsideClickIgnoreClass}
                     fitTargetWidth={this.props.popoverFitTargetWidth}
                     style={this.props.popoverStyle}>

                {this.props.searchable && this.props.options && this.props.options.length>10 &&
                <Search searchString={this.state.searchString} onSearch={this.onSearchChange} onEscapePressed={this.props.hidePopover}/>}

                {content}

                {this.props.showHelp &&
                <div className="help">
                    <div className="ui5-link-small" onClick={this.props.onManageOptions}>{this.props.manageLabel}</div>
                </div>}
            </Popover>
        );
    }
}

module.exports = PopoverSelect;
